import moment, { Moment } from 'moment'

function normalize(value: string | Date | Moment): string | Moment {
  if (value instanceof Date) {
    return value.toISOString()
  }

  return value
}

export function datetime(value: string | Date): string {
  const day = moment(normalize(value), 'YYYY-MM-DDTHH:mm:ss')
  return day.format('YYYY/MM/DD HH:mm:ss')
}

export function date(value: string | Date | Moment): string {
  const day = moment(normalize(value), 'YYYY-MM-DD')
  return day.format('YYYY/MM/DD')
}

export function time(value: string | Date | Moment): string {
  const day = moment(normalize(value), 'HH:mm')
  return day.format('HH:mm')
}

export function japaneseDateTimeFormat(value: string | Date | Moment) {
  const formatToDay = moment(value).format('ddd日')
  const formatToDate = moment(value).format('YYYY年MM月DD日')

  return {
    dayName: formatToDay,
    date: formatToDate,
  }
}

export function firstDayOfMonthWithTime(value: string | Date | Moment): string {
  const month = moment(value).format('YYYY-MM')
  return `${month}-01T00:00:00`
}

export function getListOfFullMonthDates(data: Date | Moment) {
  const daysInMonth = []

  const monthDate = moment(data).startOf('month')

  for (let i = 0; i < monthDate.daysInMonth(); i++) {
    const newDay = monthDate.clone().add(i, 'days')
    daysInMonth.push(newDay.format('D ddd'))
  }

  return daysInMonth
}
